import { render, staticRenderFns } from "./ManterMinutaExibir.vue?vue&type=template&id=037c5bbf&scoped=true&"
import script from "./ManterMinutaExibir.vue?vue&type=script&lang=js&"
export * from "./ManterMinutaExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c5bbf",
  null
  
)

export default component.exports